<div class="mt-1">
  <div class="grid">
    <div class="col-12">
      <p-table class="datatable" [value]="checkLicenseNoList" dataKey="id" editMode="row">
        <ng-template pTemplate="header">
            <tr>
                <th>Do</th>
                <th>License No</th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-checkLicenseNoBean let-editing="editing" let-ri="rowIndex">
            <tr>
                <td>
                  {{checkLicenseNoBean.doNo}}
                </td>
                <td>
                  <div>
                    <input pInputText [(ngModel)]="checkLicenseNoBean.licenseNo" [ngModelOptions]="{standalone: true}"
                    [class]="showMsgByLicenseNoEmpty(checkLicenseNoBean.licenseNo)"/>
                    <div *ngIf="showLicenseNoEmpty" >
                      <small *ngIf="showLicenseNoEmpty"
                        class="p-invalid">{{ 'Common.Button.Required' | translate }}</small>
                    </div>
                  </div>
                </td>
            </tr>
        </ng-template>
      </p-table>
    </div>
  </div>
  <div class="grid mt-2">
    <div class="col text-center">
      <button pRipple pButton label="{{ 'Common.Button.Confirm' | translate }}" (click)="confirmBtnClick($event)"></button>
    </div>
  </div>

</div>
